import { render, staticRenderFns } from "./KLiveRegion.vue?vue&type=template&id=86d560c8"
import script from "./KLiveRegion.vue?vue&type=script&lang=js"
export * from "./KLiveRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports